import type { DemoKey } from '../types';

export const th: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'คณิตศาสตร์ · สถิติ',
  'app.title': 'สถิติ',
  'panel.experiment': 'ฉาก',
  'panel.params': 'พารามิเตอร์',

  'exp.survey-explorer.title': 'นักสำรวจแบบสอบถาม',
  'exp.survey-explorer.desc': 'เลือกคอลัมน์; เดโมเลือกสรุปที่เหมาะสม',
  'exp.distribution-sculptor.title': 'นักปั้นการแจกแจง',
  'exp.distribution-sculptor.desc': 'ลากจุดและดูสถิติตอบสนอง',
  'exp.two-variable-lab.title': 'ห้องทดลองสองตัวแปร',
  'exp.two-variable-lab.desc': 'การกระจาย การปรับ และคำถามเรื่องเหตุ',
  'exp.sampling-lab.title': 'ห้องทดลองสุ่มตัวอย่าง',
  'exp.sampling-lab.desc': 'เทคนิคและขนาดเลื่อนค่าเฉลี่ยตัวอย่างอย่างไร',
  'exp.probability-diagrams.title': 'แผนผังความน่าจะเป็น',
  'exp.probability-diagrams.desc': 'มุมมองเวนน์และต้นไม้สำหรับเหตุการณ์รวม',

  'type.qualitative-nominal.label': 'เชิงคุณภาพ · นาม',
  'type.qualitative-nominal.def': 'หมวดหมู่ที่ไม่มีลำดับ',
  'type.qualitative-ordinal.label': 'เชิงคุณภาพ · ลำดับ',
  'type.qualitative-ordinal.def': 'หมวดหมู่ที่มีลำดับชัดเจน',
  'type.qualitative-multi.label': 'เชิงคุณภาพ · หลายค่า',
  'type.qualitative-multi.def': 'แต่ละการสังเกตมีหลายแท็กได้',
  'type.quantitative-discrete.label': 'เชิงปริมาณ · ไม่ต่อเนื่อง',
  'type.quantitative-discrete.def': 'ตัวเลขเป็นขั้นคงที่',
  'type.quantitative-continuous.label': 'เชิงปริมาณ · ต่อเนื่อง',
  'type.quantitative-continuous.def': 'ตัวเลขที่วัดบนสเกลต่อเนื่อง',

  'column.name.label': 'ชื่อนักเรียน',
  'column.height_cm.label': 'ส่วนสูง',
  'column.shoe_size_eu.label': 'ขนาดรองเท้า (EU)',
  'column.study_hours.label': 'ชั่วโมงเรียน / สัปดาห์',
  'column.test_score.label': 'คะแนนสอบ',
  'column.sports_played.label': 'กีฬาที่เล่น',
  'column.eye_color.label': 'สีตา',
  'column.commute_min.label': 'เดินทาง',
  'column.grade_year.label': 'ชั้นปี',
  'column.homework_effort.label': 'ความพยายามในการบ้าน',
  'column.ice-cream-sales.label': 'ยอดขายไอศกรีม',
  'column.drownings.label': 'การจมน้ำ',
  'column.month.label': 'เดือน',
  'column.storks.label': 'นกกระสา',
  'column.births.label': 'การเกิด',
  'column.country_area_km2.label': 'พื้นที่ประเทศ',
  'column.sleep_hours.label': 'ชั่วโมงนอน',
  'column.reaction_ms.label': 'เวลาตอบสนอง',

  'dataset.master-survey.label': 'สำรวจห้องเรียน',
  'dataset.master-survey.desc': 'นักเรียนจำลอง 30 คน',
  'dataset.spurious-ice-cream-vs-drownings.label': 'ไอศกรีม vs จมน้ำ',
  'dataset.spurious-ice-cream-vs-drownings.desc':
    'ทั้งคู่ขึ้นลงตามฤดูกาล การจมน้ำไม่ใช่เหตุของยอดไอศกรีม',
  'dataset.spurious-storks-vs-births.label': 'นกกระสา vs การเกิด',
  'dataset.spurious-storks-vs-births.desc': 'ประเทศใหญ่กว่ามีนกและการเกิดมากกว่า นกไม่ใช่เหตุ',
  'dataset.real-sleep-vs-reaction-time.label': 'นอน vs เวลาตอบสนอง',
  'dataset.real-sleep-vs-reaction-time.desc':
    'นอนมากขึ้น ตอบสนองเร็วขึ้น สหสัมพันธ์เชิงลบจริง — กลไกสมเหตุสมผล',

  'tag.football.label': 'ฟุตบอล',
  'tag.basketball.label': 'บาสเกตบอล',
  'tag.volleyball.label': 'วอลเลย์บอล',
  'tag.swimming.label': 'ว่ายน้ำ',
  'tag.none.label': 'ไม่มี',

  'population.gaussian.label': 'โค้งระฆัง',
  'population.right-skewed.label': 'เบ้ขวา',
  'population.bimodal.label': 'สองยอด',
  'population.uniform.label': 'สม่ำเสมอ',

  'venn.dice-even-or-prime.label': 'ลูกเต๋า: คู่หรือเฉพาะ',
  'venn.class-sports-2set.label': 'กีฬา (2 เซต)',
  'venn.class-sports-3set.label': 'กีฬา (3 เซต)',
  'venn.custom.label': 'กำหนดเอง',

  'tree.draw-without-replacement.label': 'จับไม่คืน',
  'tree.custom.label': 'กำหนดเอง',
  'tree.coin.heads': 'หัว',
  'tree.coin.tails': 'ก้อย',
  'tree.draw.start': 'ถุง: แดง 2, น้ำเงิน 3',
  'tree.draw.red': 'แดง',
  'tree.draw.blue': 'น้ำเงิน',
  'tree.custom.start': 'เริ่ม',
  'tree.custom.A': 'A',
  'tree.custom.B': 'B',

  'card.histogram': 'ฮิสโตแกรม',
  'card.cumulative': 'ความถี่สะสม',
  'card.box': 'บ็อกซ์พล็อต',
  'card.summary': 'สรุป 5 เลข',
  'card.bar': 'แผนภูมิแท่ง',
  'card.mode': 'ฐานนิยม',
  'card.tag-frequency': 'ความถี่แท็ก',
  'card.mode-tag': 'แท็กยอดนิยม',
  'card.empty-no-order': 'ไม่ใช้',
  'card.empty-multi': 'ไม่ใช้',
  'card.numberline': 'เส้นจำนวน',
  'card.scatter': 'การกระจาย',
  'card.description': 'เกิดอะไรขึ้น',
  'card.population': 'ประชากร',
  'card.sampling-distribution': 'ค่าเฉลี่ยตัวอย่าง',
  'card.venn': 'เวนน์',
  'card.tree': 'ต้นไม้',
  'card.probabilities': 'ความน่าจะเป็น',

  'param.dataset.label': 'ชุดข้อมูล',
  'param.column.label': 'คอลัมน์',
  'param.bins.label': 'ช่วง',
  'param.shape.label': 'รูปเริ่มต้น',
  'param.show-mean.label': 'แสดงค่าเฉลี่ย',
  'param.show-median.label': 'แสดงมัธยฐาน',
  'param.x-col.label': 'คอลัมน์ X',
  'param.y-col.label': 'คอลัมน์ Y',
  'param.show-regression.label': 'เส้นถดถอย',
  'param.show-residuals.label': 'เศษเหลือ',
  'param.show-confounder.label': 'แสดงตัวแปรกวน',
  'param.population.label': 'ประชากร',
  'param.technique.label': 'เทคนิค',
  'param.sample-size.label': 'ขนาดตัวอย่าง',
  'param.stratum.label': 'ชั้น',
  'param.bias.label': 'อคติ',
  'param.mode.label': 'โหมด',
  'param.preset.label': 'พรีเซ็ต',
  'param.universe.label': 'ขนาดเอกภพ',
  'param.show-prob.label': 'แสดงความน่าจะเป็น',
  'param.treat-as-numeric.label': 'ถือเป็นตัวเลข',

  'stat.count': 'จำนวน',
  'stat.mean': 'ค่าเฉลี่ย',
  'stat.median': 'มัธยฐาน',
  'stat.range': 'พิสัย',
  'stat.q1': 'Q1',
  'stat.q3': 'Q3',
  'stat.iqr': 'IQR',
  'stat.outliers': 'ค่าผิดปกติ',
  'stat.r': 'Pearson r',
  'stat.r2': 'r²',
  'stat.slope': 'ความชัน',
  'stat.intercept': 'จุดตัด',
  'stat.n': 'n',
  'stat.population-mean': 'ค่าเฉลี่ยจริง',
  'stat.latest-sample-mean': 'ค่าเฉลี่ยตัวอย่าง',
  'stat.sample-mean-spread': 'SD ค่าเฉลี่ยตัวอย่าง',
  'stat.sample-count': 'จำนวนตัวอย่างที่สุ่ม',
  'outlier.upper': 'ค่าผิดปกติบน',
  'outlier.lower': 'ค่าผิดปกติล่าง',

  'region.A': 'A',
  'region.B': 'B',

  'btn.resample': 'สุ่มใหม่',
  'btn.run-100': 'สุ่ม 100 ครั้ง',
  'btn.stop': 'หยุด',
  'btn.clear-history': 'ล้างประวัติ',

  'explainer.no-order': 'ไม่มีลำดับ → ไม่มีสะสม ไม่มีบ็อกซ์',
  'explainer.multi-no-iqr': 'หลายค่า → ควอไทล์ / IQR ไม่นิยาม',
  'message.no-data': 'ไม่มีข้อมูล',
  'message.needs-quartiles': 'ต้องการ ≥4 จุดสำหรับควอไทล์',
  'message.x-zero-variance': 'ความแปรปรวน X เป็นศูนย์ — ไม่มีเส้นปรับ',
  'message.n-too-small': 'n เล็กเกินไป',
  'message.stratum-clamp': 'ชั้นมีแถวน้อยกว่าที่ขอ — ใช้ทั้งหมด',
  'message.siblings-sum-to-one': 'พี่น้องต้องรวมเป็น 1',
};
